import { createSelector, createStructuredSelector } from 'reselect'
import { createGetState } from '../Redux/selector'
import { createStateSelector } from '../Redux/utils'
import { getSubmitTarget } from './utils'
import { createDataSelector } from './reducer'

export const mapStateToProps = () => {

    const getState = createGetState()
    const submit = createStateSelector(getSubmitTarget, false)
    const data = createDataSelector()

    const mapLocalStateToProps = createStructuredSelector({
        submit,
        data
    })

    return createSelector(
        getState,
        (_, props) => props,
        mapLocalStateToProps
    )
}
